import {
  Box,
  Flex,
  HStack,
  Spinner,
  Stack,
  Text,
  Textarea,
  useToast,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import { Heading, ReactSelect } from '~/components';
import { useCompanyAsSelect, useJSON } from '~/hooks';

export const HistJSON: React.VFC = () => {
  const [page, setPage] = useState(1);
  const toast = useToast();
  const {
    data: companies,
    isLoading: isCompaniesLoading,
    isError: isCompaniesError,
  } = useCompanyAsSelect();
  const [id_json, setCompany] = useState<string>('0');
  const { data, isLoading, isError, isFetching } = useJSON(id_json);

  let isStarting = true;

  function handleCompanySelection(e: any) {
    isStarting = false;
    setCompany(e.value);
  }

  return (
    <Box px="8" py="2">
      <Heading hasBackButton>JSON Carga SAP</Heading>
      <Flex
        flexDir="column"
        flexWrap="wrap"
        w="100%"
        py={1}
        gridGap="12"
        style={{
          position: 'relative',
        }}
        fontSize="14px"
      />
      <Flex pt={2} flexDir="column" w="100%">
        <Flex justify="space-between" py={1}>
          <Flex align="end" gridGap={4} mb={1}>
            <Flex align="end" gridGap={4}>
              {/* <Select
                name="id_json"
                placeholder="Selecione"
                label="Código de Cliente"
                defaultValue={id_json}
                onChange={e => handleCompanySelection(e)}
              > */}
              <ReactSelect
                isSearchable
                defaultStyle
                options={companies}
                label="Código de Cliente"
                placeholder="Selecione o Código de Cliente"
                onChange={changes => handleCompanySelection(changes)}
              />
              {/* {companies &&
                  companies.map(company => (
                    <option key={company.value} value={Number(company.value)}>
                      {company.label}
                    </option>
                  ))}
              </Select> */}
            </Flex>
            {(isFetching || isCompaniesLoading) && <Spinner mb={2} />}
          </Flex>
        </Flex>
        {isLoading || isCompaniesLoading ? (
          <Flex justify="center">
            <Spinner />
          </Flex>
        ) : isError ? (
          <Flex justify="center">
            <Text>Falha ao obter dados das faturas.</Text>
          </Flex>
        ) : isCompaniesError ? (
          <Flex justify="center">
            <Text>Falha ao obter lista de empresas.</Text>
          </Flex>
        ) : (
          <Box px="8" py="0">
            <Flex
              flexDir="column"
              flexWrap="wrap"
              w="100%"
              py={1}
              gridGap="12"
              style={{
                position: 'relative',
              }}
              fontSize="14px"
            >
              <Flex>
                <HStack gridGap={10}>
                  <Text>Data atualização:</Text>
                  <Text>
                    {id_json !== '0'
                      ? data?.dh_ultimaatualizacao || '-'
                      : '(selecione um cliente)'}
                  </Text>
                </HStack>
              </Flex>
              <Flex>
                <Stack>
                  <Text>Ultimo JSON recebido:</Text>
                </Stack>
              </Flex>
            </Flex>
            <Stack>
              {id_json !== '0' && data && (
                <Textarea
                  value={JSON.stringify(data?.text)}
                  height={350}
                  readOnly
                />
              )}
            </Stack>
          </Box>
        )}
      </Flex>
    </Box>
  );
};
